<div class="storm-details-container">
  <div class="panel-title">
    Storm {{ storm.name }}
  </div>
  <div class="panel-content">
    <div>
      Start: {{ storm.startTime | date:'MMM d h:mma' }}
    </div>
    <div>
      End: {{ storm.endTime | date:'MMM d h:mma' }}
    </div>

    @if (stormStats.distanceDriven > 0) {
      <div>
        {{ stormStats.distanceDriven | distance:configuration.useMetricSystem:false }} Total {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }}
      </div>
    }
    @if (stormStats.distancePlowed > 0) {
      <div>
        {{ stormStats.distancePlowed | distance:configuration.useMetricSystem:false }} {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }} Plowed
      </div>
    }
    @if (stormStats.distanceSpreadGranular > 0) {
      <div>
        {{ stormStats.distanceSpreadGranular | distance:configuration.useMetricSystem:false }} {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }} Granular Spread
      </div>
    }
    @if (stormStats.distanceSpreadLiquid > 0) {
      <div>
        {{ stormStats.distanceSpreadLiquid | distance:configuration.useMetricSystem:false }} {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }} Liquid Spread
      </div>
    }
    @if (stormStats.materialUsedGranular > 0) {
      <div>
        {{ stormStats.materialUsedGranular | weight:configuration.useMetricSystem }} Granular
      </div>
    }
    @if (stormStats.materialUsedLiquid > 0) {
      <div>
        {{ stormStats.materialUsedLiquid | volume:configuration.useMetricSystem }} Liquid
      </div>
    }
    @if (stormStats.distanceMowed > 0) {
      <div>
        {{ stormStats.distanceMowed | distance:configuration.useMetricSystem:false }} {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }} Mowed
      </div>
    }
    @if (stormStats.distanceSwept > 0) {
      <div>
        {{ stormStats.distanceSwept | distance:configuration.useMetricSystem:false }} {{ configuration.useMetricSystem ? 'Kilometers' : 'Miles' }} Swept
      </div>
    }
  </div>

  <div>
    @for (shift of shiftMenuItems; track shift.id) {
      <app-action-menu-item [input]="shift"></app-action-menu-item>
    }
  </div>
</div>
